/* global modForm */
/**
 * Registers a `change` listener on `[name="homePhone"]` for Trestle activity-score soft reject.
 *
 * **Requires**: `modForm.opts.useTrestleApiToTrackPhoneValidity` and `modForm.opts.trestlePhoneValidityMinActivityScore`.
 *
 * **Behavior**:
 * - On blur/change, if phone passes `isFieldValid(..., 'phone')`, calls `getTrestlePhoneValidityScore`
 * - Stores the in-flight promise on `modForm.trestlePhoneValidationPromise` for submit to await
 * - If score is less than or equal to min, marks the field invalid (does not block the main thread; no await in the listener)
 *
 * @returns {void}
 */

import { isFieldValid } from '../../validators';
import { markFieldAsInvalid } from '../components/input/markFieldAsInvalid';
import { getTrestlePhoneValidityScore } from '../requests/getTrestlePhoneValidityScore';

export function trackPhoneValidityWithTrestle() {
	const phoneField = document.querySelector('[name="homePhone"]');
	const minScore = modForm.opts.trestlePhoneValidityMinActivityScore;

	if (!phoneField) {
		return;
	}
	phoneField.addEventListener('change', () => {
		const phoneValue = phoneField.value;
		if (!isFieldValid(phoneField, 'phone')) {
			return;
		}
		modForm.trestlePhoneValidationPromise = getTrestlePhoneValidityScore(phoneValue).then(() => {
			if (modForm.phoneActivityScore && modForm.phoneActivityScore <= minScore && phoneValue === phoneField.value) {
				markFieldAsInvalid(phoneField);
			}
		});
	});
}